import packageJson from '@/../package.json';
import type { SiamAuthStoreOptions } from '@sit/vue-core';
import { Log, UserManagerSettings } from 'oidc-client-ts';

/** Global app configuration. */
const config = {
  app: {
    /** The name of the app (will be displayed inside the topbar) */
    name: 'Gateway',
    /** Current app version as defined in package.json. */
    version: packageJson.version,
    /** The base URL the application bundle will be deployed at. */
    baseUrl: import.meta.env.BASE_URL,
  },
  i18n: {
    /**
     * Mapping of BCP 47 language codes (= local file inside i18n/locales without .json extension) to the written name of the language
     */
    locales: {
      'en-US': 'English',
      'de-DE': 'Deutsch',
    } as Record<string, string>,
  },
  api: {
    // host: 'https://lidl-gateway-be-main.api.dev.sit.sys.odj.cloud/',
    host: import.meta.env.ODJ_DEP_GATEWAY_ENDPOINT_BE_MAIN.includes('localhost')
      ? 'https://lidl-gateway-be-main.api.dev.sit.sys.odj.cloud/' //'http://127.0.0.1:8080/'
      : import.meta.env.ODJ_DEP_GATEWAY_ENDPOINT_BE_MAIN,
  },
  auth: {
    idp: import.meta.env.ODJ_DEP_GATEWAY_AUTH_IDP,
    clientId: import.meta.env.ODJ_DEP_GATEWAY_AUTH_CLIENT_ID,
    scope: 'openid siambasicuserprofile gateway',
    groupsAttribute: 'groupmembership',
    overrides: {
      loadUserInfo: true,
    } as Partial<UserManagerSettings>,
    // setze bei lokalem Backend disabled auf 'true'
    disabled: false,
    redirectUrl: '/',
    logLevel: getLogLevel(),
    useDecryptedAccessToken: true,
  } satisfies SiamAuthStoreOptions,
};

function getLogLevel(): Log {
  const { MODE } = import.meta.env;
  if (MODE === 'development') return Log.DEBUG;
  if (MODE === 'test') return Log.NONE;
  return Log.ERROR;
}

export default config;
